import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    premium: {
      backgroundColor: '#27874e',
      color: '#ffffff',
      padding: '3px 5px',
      marginLeft: 10,
      borderRadius: 5,
    },
  }),
);
interface BadgeProps {
  rank: any;
  showToPlanType: any;
}
export default function BadgeComponent({ rank, showToPlanType }: BadgeProps) {
  const classes = styles1();
  if (rank < showToPlanType) {
    return <div className={classes.premium}>Premium</div>;
  }
  return null;
}
